import { useLocalization } from '@/hooks/useLocalization';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import { GOAL_OPTIONS } from '@/utils/constants';

export default function GoalScreen() {
  const { t } = useLocalization();
  const { chooseGoal } = useChat();

  return (
    <BotMessage text={t('goal.message')}>
      <ScreenOptions>
        {GOAL_OPTIONS.map(opt => (
          <OptionButton key={opt.value} onClick={() => chooseGoal(opt.value)}>
            {t(opt.labelKey)}
          </OptionButton>
        ))}
      </ScreenOptions>
    </BotMessage>
  );
}
